import React, { useState, useEffect } from 'react';
import UserFormPopup from './UserFormPopup';
import { useParams } from 'react-router-dom';
import { getPermissions, getRoles } from '../../../actions/organization';
import isArray from 'lodash.isarray';
import { getUsers } from '../../../actions/user/action';
import CustomPagination from '../../Promotion/CustomPagination';
import { useSelector } from 'react-redux';

const UserManagement = ({ subject = null, brandId = null }) => {
  const { organizationTree } = useSelector((state) => state?.organization);
  const [permissions, setPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageOffset, setPageOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    if (organizationTree?.organizationId) {
      getUsersFunc();
      getRolesFunc();
    }
  }, [organizationTree]);

  useEffect(() => {
    getPermissionsFunc();
  }, []);

  useEffect(() => {
    getUsersFunc();
  }, [pageOffset]);

  const getPermissionsFunc = async () => {
    try {
      const res = await getPermissions();
      if (res?.length > 0 && isArray(res)) {
        setPermissions([...res]);
        setTotalPages(res?.totalPages);
      } else {
        setPermissions([]);
        setTotalPages(0);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getRolesFunc = async () => {
    try {
      const data = {
        input: {
          pageSize: 1000,
          pageOffset: 0,
          filters: {
            subject: subject,
            brandId: brandId,
            organizationId: organizationTree?.organizationId,
          },
        },
      };
      const res = await getRoles(data);
      if (res?.roles?.length > 0 && isArray(res?.roles)) {
        setRoles([...res?.roles]);
      } else {
        setRoles([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getUsersFunc = async () => {
    try {
      const data = {
        input: {
          pageSize: pageSize,
          pageOffset: pageOffset,
          filters: {
            roles: {
              brandId: brandId,
            },
          },
        },
      };
      const res = await getUsers(data);

      if (res?.users?.length > 0 && isArray(res?.users)) {
        setUsers([...res?.users]);
      } else {
        setUsers([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const updateHandler = () => {
    try {
      getUsersFunc();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="page-content">
      <div className="d-flex flex-row align-items-center justify-content-between">
        <h5>Users</h5>
        <UserFormPopup
          subject={subject}
          updateHandler={updateHandler}
          permissions={permissions}
          roles={roles}
          brandId={brandId}
        />
      </div>
      <div className="mt-4">
        <table className="table table-nowrap table-centered align-middle mb-0">
          <thead className="bg-light fs-14">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Role</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="fs-13">
            {users?.map((user, index) => {
              return (
                <tr key={user?._id}>
                  <td>{index + 1}</td>
                  <td>{`${user?.firstName} ${user?.lastName}`}</td>
                  <td>{user?.email}</td>
                  <td>{user?.mobile}</td>
                  <td>{user?.roles?.[0]?.name}</td>
                  <td>{user?.status}</td>
                  <td>
                    <UserFormPopup
                      subject={subject}
                      updateHandler={updateHandler}
                      permissions={permissions}
                      roles={roles}
                      user={user}
                      brandId={brandId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <CustomPagination
          pageOffset={pageOffset}
          totalPages={totalPages}
          setPageOffset={setPageOffset}
        />
      </div>
    </div>
  );
};

export default UserManagement;
